import React from 'react';

import { Breadcrumb, Button, Card, Col, message, Row } from 'antd';

import { _getFeaturedCategories, _postFeaturedCategories} from './actions';

import FeaturedModal from './modal';
import SortableFeaturedList from './sortable-featured-list';

import './index.css';


class FeaturedCategory extends React.Component {
    render() {
        const { featuredCategories } = this.state || {};
        
        return(
            <div>
                <Card 
                    title={
                        <div>
                            <Breadcrumb separator="|">
                                <Breadcrumb.Item>Home Page</Breadcrumb.Item>
                                <Breadcrumb.Item className="active-breadcrumb">Featured</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>}
                    extra={ 
                        <Row>
                            <Col span={12}>
                                <Button 
                                    type="primary"
                                    disabled={this.state.notEdited}
                                    onClick={this.saveFeaturedCategories}>
                                    Save Changes
                                </Button>
                            </Col>

                            <Col span={12}>
                                <Button onClick={this.onAddModal}>
                                    Add a Category
                                </Button>
                            </Col>
                        </Row>}
                        >


                    {(featuredCategories)?
                    <Row>

                        {(featuredCategories.length <1)?
                            <div>
                                No Featured Categories
                            </div> 
                        : 
                            <SortableFeaturedList 
                            featuredCategories={featuredCategories}
                            toggleActive={this.toggleActive}
                            onEdit={this.onEdit}
                            updateEdited={this.updateEdited}
                            updateFeaturedCategories={this.updateFeaturedCategories}
                        />
                        }
                        
                    </Row>
                    :
                    ''
                    }

                    {this.renderEditModal()}
                    

                </Card>
            </div>
        )
    }

    renderEditModal = () => {
        
        const { 
            activeCategory, 
            activePosition,
            editModal,
            isNewCategory,
            newCategorySchema
        } = this.state;

        if(!editModal){
            return null;
        }

        if(isNewCategory){
            
            return (
                <FeaturedModal 
                    activeCategory={newCategorySchema}
                    activePosition={0}
                    toggleVisibility={this.toggleVisibility} 
                    updateActiveCategory={this.updateActiveCategory}
                    visible={editModal}/>
            )
        }
         
        
        return(
            <FeaturedModal 
                activeCategory={activeCategory}
                activePosition={activePosition} 
                toggleVisibility={this.toggleVisibility} 
                updateActiveCategory={this.updateActiveCategory}
                visible={editModal}/>
        )

    }

    constructor(props) {
        super(props);

        const newCategorySchema = {
            active: true,
            position: '',
            items: [
                {
                    title: '',
                    src:'',
                    link: '',
                    position: 0
                },
                {
                    title: '',
                    src:'',
                    link: '',
                    position: 1
                },
                {
                    title: '',
                    src:'',
                    link: '',
                    position: 2
                    
                },
                {
                    title: '',
                    src:'',
                    link: '',
                    position: 3
                },
                {
                    title: '',
                    src:'',
                    link: '',
                    position: 4
                },
            ],
            title: '',
        }

        this.state = {
            editModal: false,
            newCategorySchema,
            activePosition: 0,
            activeCategory: false,
            featuredCategories: false,
            isNewCategory: false,
            notEdited: true
        }
    }


    componentWillMount() {

        _getFeaturedCategories()
        .then( res => {
            if(res.data.length<1) {
                this.setState({
                    featuredCategories: []
                })
            }
            if(res.data.length>0) {
                this.setState({
                    featuredCategories: res.data
                })
            }
        })

    }

    onAddModal = () => {
        

        this.setState({
            editModal: true,
            activeCategory: this.state.newCategorySchema,
            isNewCategory: true
        })
        // const isNewCategory = true;
        // this.renderEditModal();
        

    }

    onEdit = (position) => {
        const activePosition = position;

        this.setState({
            editModal: true,
            activePosition,
            activeCategory: this.state.featuredCategories[position]
        })
        
    }

    saveFeaturedCategories = () => {
        const { featuredCategories } = this.state;
        _postFeaturedCategories(featuredCategories)
        .then ( res => {
            const {status} = res.request;
            if(status ===200) {
                message.success("Updated")
            } else {
                message.error("Error")
            }

            this.setState({
                notEdited: true
            })
        })
    }

    toggleActive = (position) => {
        this.setState({
            featuredCategories: [
                ...this.state.featuredCategories.map(
                    fc => {
                        if(fc.position === position) {
                            return {
                                ...fc,
                                active: !fc.active
                            }
                        } else {
                            return {...fc}
                        }
                    }
                )
            ],
            notEdited: false
        })
    }
    
    toggleVisibility = () => {
        this.setState({
            editModal: false
        })
    }

    updateActiveCategory = (activeCategory) => {
        const { active, items, position, title } = activeCategory;


        if(this.state.isNewCategory) {
            const { featuredCategories } = this.state;

            //Push up index & position of featuredCategories [ 0 to .length ] by one

            for (let i = featuredCategories.length; i>= 1; i--){
                featuredCategories[i] = featuredCategories[i-1];
                featuredCategories[i].position ++;
            }

            featuredCategories[0] = activeCategory;
            featuredCategories[0].position = 0;
            this.setState({
                isNewCategory: false,
            })
        } else {
            this.setState({
                ...this.state,
                featuredCategories: [
                    ...this.state.featuredCategories.map(
                        ( featuredCategory, i ) => {
                            if(i === position) {
                                return {
                                    active, 
                                    items,
                                    position,
                                    title
                                }
                            }
                            else {
                                return {...featuredCategory};
                            }
                        }
                    )
                ],
                activeCategory
            })
        }

        this.setState({
            isNewCategory: false,
            notEdited: false
        })
        
        setTimeout(() => {
        }, 100)
    }

    updateEdited = () => {
        this.setState({
            notEdited: false
        })
    }

    updateFeaturedCategories = (featuredCategories) => {
        if(this.state.featuredCategories !== featuredCategories) {
            this.setState({
                featuredCategories,
                notEdited: false
            })
        }

    }

    
}

export default FeaturedCategory;



// WEBPACK FOOTER //
// ./src/components/featured/index.js